"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTagOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M10 6a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2z" }),
        React.createElement("path", { d: "M15.43 2H2v12.41l15.67 15.67.52-.1a15.78 15.78 0 007.48-4.31A15.78 15.78 0 0030 18.19l.1-.5zm8.83 22.26a14.51 14.51 0 01-6 3.63L4 13.59V4h10.57L27.9 18.28a14.45 14.45 0 01-3.64 5.98z" })));
}
exports.default = SvgTagOutline;
//# sourceMappingURL=TagOutline.js.map